/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function e(e, t, l, n) {
  var u = null,
      a = 1e3;
  "number" == typeof t ? (a = t, n = l) : (u = null != t ? t : null, a = l);
  var o,
      p = 0;

  var r = function r() {
    p = 0, e.apply(n, o);
  },
      c = function c() {
    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    u && u.apply(n, e), o = e, a ? p || (p = setTimeout(r, a)) : r();
  };

  return c.remove = function () {
    p && (clearTimeout(p), p = 0);
  }, c.forceUpdate = function () {
    p && (clearTimeout(p), r());
  }, c.hasPendingUpdates = function () {
    return !!p;
  }, c;
}

export { e as default, e as throttle };